import styled from "styled-components";
import { designTokens } from "../ui/foundation/DesignTokens";

// Card container for the table
export const TableCard = styled.div`
  background: white;
  border-radius: ${designTokens.radius.lg};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${designTokens.colors.gray[200]};
  overflow: hidden;
`;

export const TableCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid ${designTokens.colors.gray[200]};
`;

export const TableCardTitle = styled.h2`
  font-family: ${designTokens.fonts.heading};
  font-size: 1.125rem;
  font-weight: 700;
  color: ${designTokens.colors.gray[900]};
  margin: 0;
`;

// Agent cell with avatar
export const AgentCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AgentAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: ${designTokens.radius.full};
  background: ${props => props.bgColor || designTokens.colors.primary[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${designTokens.fonts.heading};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.textColor || designTokens.colors.primary[700]};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AgentName = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${designTokens.colors.gray[900]};
`;

export const AgentRole = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.75rem;
  color: ${designTokens.colors.gray[500]};
`;

// Status badge
export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: ${designTokens.radius.full};
  font-family: ${designTokens.fonts.body};
  font-size: 0.75rem;
  font-weight: 500;

  ${props => {
    switch (props.status) {
      case 'online':
        return `
          background: rgba(5, 150, 105, 0.1);
          color: #059669;
        `;
      case 'offline':
        return `
          background: ${designTokens.colors.gray[100]};
          color: ${designTokens.colors.gray[600]};
        `;
      case 'away':
        return `
          background: rgba(245, 158, 11, 0.1);
          color: #D97706;
        `;
      default:
        return `
          background: ${designTokens.colors.gray[100]};
          color: ${designTokens.colors.gray[600]};
        `;
    }
  }}
`;

export const StatusDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;

// Rating display
export const RatingDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    width: 14px;
    height: 14px;
    color: #FBBF24;
  }
`;

export const RatingValue = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 500;
  color: ${designTokens.colors.gray[900]};
`;

// Metric value with optional trend
export const MetricValue = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 500;
  color: ${designTokens.colors.gray[900]};
`;

// Empty state
export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
`;

export const EmptyStateText = styled.p`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  color: ${designTokens.colors.gray[500]};
  margin: 0;
`;
